import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";

// Eager metadata registration; the render component (Form) code-splits into its
// own tpl-form-widget chunk, loaded on demand when the widget renders.
registerCardTemplate({
    id: 'form-widget',
    name: 'Form',
    description: 'A data entry form to collect information',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-form-widget" */ "./Form")),
    designModes: {
        uiPropsKey: 'formMode',
        defaultValue: 'form',
        options: [
            { value: 'form', label: 'Form View' },
            { value: 'result', label: 'Response View' },
        ],
    },
    canDragDropFields: true,
    icon: ['fas', 'credit-card-blank'],
    complexity: 'medium',
    autoHieght: true
});
